import { memo, useCallback } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";
import { ListItem, ListItemText, ListItemAvatar, Avatar } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useToCDNUrl } from "hooks/useCDN";

const PanelListItem = ({ markerId, roomId }) => {
  const dispatch = useAppDispatch();
  const [t] = useTranslation();
  const toCDNUrl = useToCDNUrl();
  const marker = useAppSelector(
    (state) => store.getRoomMarkerById(state, roomId, markerId),
    shallowEqual
  );

  const onEdit = useCallback(() => {
    dispatch(
      store.appStateMutate((state) => {
        state.openRoomMarkerDetail = true;
        state.openRoomMarkerDetailId = markerId;
      })
    );
  }, [markerId, dispatch]);

  return (
    <ListItem button onClick={onEdit}>
      <ListItemAvatar>
        <Avatar src={toCDNUrl(marker.imageUrl)} />
      </ListItemAvatar>
      <ListItemText
        primary={marker.text || t("NOTEXT")}
        primaryTypographyProps={{ noWrap: true, display: "block" }}
        secondary={`[${marker.z}] ${marker.width} × ${marker.height}`}
        secondaryTypographyProps={{ noWrap: true }}
      />
    </ListItem>
  );
};

export default memo(PanelListItem);
